import React from "react";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="wrapper--narrow section-padding">
      <div className="text__standard" data-accordion-group="">
        <p className="standard__kicker text-left accent-size-4">Terms</p>
        <div className="accordion__wrapper">
          <div
            className="accordion__body no-js-accordion rte body-size-4"
            data-accordion-body=""
            id="accordion-accordion_block_1_1"
          >
            <span />
            <p>
              <strong>TERMS OF SERVICE</strong>
            </p>
            <p>
              <br />
              Last updated&nbsp;March&nbsp;6,&nbsp;2023
            </p>
            <p>
              Welcome to the&nbsp;Sacuddin&nbsp;website, sacuddin.shop (the
              “Site”). The Site is operated by Sacuddin, Inc. (the “Company,”
              “we,” “us,” “our”). By accessing or using our Site you signify
              that you have read, understand and agree to be bound by these
              Terms of Service ("Terms of Service"), regardless of whether you
              are a registered user of the Site. If you do not agree to these
              Terms of Service, then do not use the Site.
            </p>
            <p>
              THESE TERMS OF SERVICE CONTAIN, AMONG OTHER THINGS, AN ARBITRATION
              PROVISION CONTAINING A CLASS ACTION WAIVER.&nbsp;
            </p>
            <p>
              These Terms of Service are effective as of the date posted above
              and we will not be bound by any additional or different terms or
              other documents that are inconsistent with these Terms of Service.
              Company may modify or update these Terms of Service at any time by
              posting the amended terms on the Site and such terms shall be
              effective for all use of the Site and Services (as defined below)
              once they are posted. Your continued access to the Site and/or use
              of the Site or the Services provided on the Site following the
              posting of any additional or different terms in the Terms of
              Service constitutes your acceptance of those additional or
              different terms. Company, in its sole discretion, may also add,
              delete or change some or all of the features of the Site or
              Company's Services at any time.
            </p>
            <p>
              These Terms of Service govern your access and use of the Site and
              all content, Services and/or products provided through the Site.
              Please read these Terms of Service carefully before using the
              Site. If you violate any of these Terms of Service (which
              incorporate by reference the Company's Privacy Policy or otherwise
              violate an agreement between you and us, the Company may terminate
              your registration, delete your profile and any content or
              information that you have posted on the Site and/or prohibit you
              from using or accessing the Site (or any portion, aspect or
              feature of the Site), at any time in its sole discretion, with or
              without notice.
            </p>
            <p>
              As used herein, “User” or "Users" means anyone who accesses and/or
              uses the Site.
            </p>
            <p>
              Our store is hosted on Shopify Inc. They provide us with the
              online e-commerce platform that allows us to sell our products and
              services to you.&nbsp;
            </p>
            <p>
              <strong>1. DESCRIPTION OF THE SERVICES</strong>Subject to the
              terms and conditions specified herein, Company offers Users
              information regarding our products and allows Users to purchase
              such products through the Site; the Site also allows Users the
              possibility to post reviews (or other user generated content),
              establish an account, sign up for product waitlists, participate
              in a contest or promotion, submit feedback or user comments,
              complete optional surveys, contact customer service or otherwise
              interact with the Site (the “Services”). Certain of our Services
              require Users to provide personal information, as detailed in our
              Privacy Policy.
              <strong>2. COLLECTION OF CUSTOMER DATA</strong>If you wish to
              purchase products from the Site or obtain information regarding
              the Services, we or our e-commerce provider will obtain contact
              and payment information from you (“Customer Data”). Certain
              payment and processing options may direct you away from the Site
              to a third-party site. By providing Customer Data, you agree: (i)
              to these Terms of Service; (ii) to provide true, accurate, current
              and complete Customer Data; (iii) to maintain and promptly update
              the Customer Data to keep it true, accurate, current and complete;
              (iv) for security reasons, to maintain the confidentiality of
              Customer Data; (v) to ensure that you properly exit from your
              account at the end of each session and to immediately notify
              Company of any unauthorized use of your account or any other
              breach of security; and (vi) to take full responsibility for all
              activities that occur under any customer account created for your
              use. Company is not responsible for any loss or damage arising
              from your failure to comply with the foregoing requirements. If
              you provide any information that is untrue, inaccurate, not
              current or incomplete, or to which you do not have rights, or if
              Company has reasonable grounds to suspect that such information is
              untrue, inaccurate, not current or incomplete, Company may suspend
              or terminate your account and refuse any and all current or future
              use of the Services (or any portion thereof).
              <strong>3. ELIGIBILITY</strong>This Site is intended solely for
              Users who are at least 16 years of age or older, and any
              registration by, use of or access to the Site by anyone who is not
              at least 16 years of age is unauthorized, unlicensed and in
              violation of these Terms of Service. By using the Services or the
              Site, you represent and warrant that you are at least 16 years of
              age or older, and that you agree to abide by all of the terms and
              conditions of these Terms of Service. If you violate any of these
              Terms of Service, or otherwise violate an agreement between you
              and us, or for any other reason, the Company may terminate your
              registration and any content or information that you have posted
              on the Site and/or prohibit you from using or accessing the
              Services or the Site (or any portion, aspect or feature of the
              Services or the Site), at any time in its sole discretion. You
              agree that the Company will not be liable to you or any third
              party for any termination of your membership, account, or use of
              or access to the Site or the Services.
              <strong>4. PROPRIETARY RIGHTS</strong>Company retains all right,
              title and interest in and to the Services, as well as all data,
              information, content and materials provided on the Services.
              Company further retains all right, title and interest in and to
              the business processes, procedures, methods and techniques used
              within the Services and all patent rights, copyright rights,
              trademark rights, trade secret rights and other intellectual
              property and proprietary rights therein existing anywhere in the
              world ("Intellectual Property") to such Services. All content on
              the Site, including but not limited to designs, text, graphics,
              pictures, video, information, software, music, sound and other
              files, and their selection and arrangement (the "Site Content"),
              are our proprietary property with all rights reserved. No Site
              Content may be modified, copied, distributed, framed, reproduced,
              republished, downloaded, displayed, posted, transmitted, or sold
              in any form or by any means, in whole or in part, without our
              prior written permission. Such unauthorized use may also violate
              applicable laws including without limitation copyright and
              trademark laws and applicable communications regulations and
              statutes. Unless explicitly stated herein, nothing in these Terms
              of Service shall be construed as conferring any license to
              intellectual property rights, whether by estoppel, implication or
              otherwise.
              <strong>5. CONTENT OF SITE AND PRODUCTS</strong>While we try to
              maintain the accuracy of the Site, we are not responsible if
              information on the Site is not accurate, complete or current. Any
              reliance on the material on this Site is at your own risk. Prices
              and descriptions for our products are subject to change without
              notice. We shall not be liable to you or to any third-party for
              any modification, suspension or discontinuance of the Site or the
              Services. Information on the Site regarding our products may
              contain typographical errors, inaccuracies or omissions that may
              relate to product descriptions, pricing, promotions, offers,
              product shipping charges, transit times and availability. We
              reserve the right to correct any errors, inaccuracies or
              omissions, and to change or update information or cancel orders if
              any information on the Site is inaccurate at any time without
              prior notice (including after you have submitted your order). We
              undertake no obligation to update, amend or clarify information on
              the Site, including, without limitation, pricing information,
              except as required by law. No specified update to the Site should
              be taken to indicate that all the information on the Site has been
              modified or updated. Products available through the Site are
              subject to our&nbsp;Return Policy. Certain products may be
              available in limited quantities. Although we have made every
              effort to display as accurately as possible the colors and images
              of our products that appear on the Site, we cannot guarantee that
              your device or computer monitor’s display of any color will be
              accurate. We reserve the right to limit the quantities of any
              products that we offer and to discontinue any product at any time.
              We reserve the right to refuse any order you place with us and, in
              our sole discretion, may limit or cancel quantities purchased per
              person or per order. In the event that we make a change to or
              cancel an order, we will attempt to notify you by contacting the
              e-mail and/or billing address or phone number provided at the time
              the order was made. We reserve the right to limit or prohibit
              orders that, in our sole judgment, appear to be placed by
              unauthorized dealers, resellers, or distributors.
              <strong>6. CONTENT SUBMITTED BY USERS</strong>By providing
              information through the Site, including any product reviews,
              photographs, comments or other submissions (“Submission”), you
              certify that your Submission consists of original material to
              which you have all the rights; that your Submission does not
              violate the rights of any third party, including, without
              limitation, copyright, trademark, patent, privacy or any rights
              creating claims for idea misappropriation or the right of
              publicity; that your Submission does not contain any material that
              is abusive, vulgar, threatening, harassing, libelous, defamatory,
              obscene or that is known to be false; and that your Submission
              does not include any private or personally identifiable
              information regarding any third party. By providing your
              Submission, you grant the Company a non-exclusive, perpetual,
              irrevocable, transferable and sublicensable worldwide right and
              license to use, reproduce, modify and otherwise exploit your
              Submission, with or without attribution, and hereby waive all
              moral rights therein; without limiting the foregoing, you further
              acknowledge and agree that any Submission will not be returned or
              kept confidential; that the Company is not obligated to use or pay
              you for the Submission; that the Company may publish the
              Submission in perpetuity in all markets worldwide and in any and
              all media now known or hereafter discovered, including the Site;
              that the Company may edit or remove content that we determine in
              our sole discretion is unlawful, offensive, threatening, libelous,
              defamatory, pornographic, obscene or otherwise objectionable or
              violates any party’s intellectual property or these Terms of
              Service; that the Submission may be edited for length, clarity
              and/or functionality; that we may display your name in conjunction
              with the Submission; and that your Submission may be shared with
              legal authorities if the Company believes it is warranted or
              appropriate, or pursuant to a legal request.
              <strong>7. REFERRAL PROGRAM</strong>The Company may at its
              discretion provide you with the opportunity to refer customers to
              the Company (“Referral Program”). In submitting referrals to the
              Company, you acknowledge that you have the right to make such
              referrals, that your referrals do not violate the privacy or other
              rights of third parties, and that your referrals do not violate
              any of these Terms of Service. You further acknowledge that the
              Company in its sole discretion may terminate the Referral Program
              at any time. If the Company terminates the Referral Program, it
              will have no obligation to compensate you for any referrals and
              your right to make referrals will terminate.
              <strong>8. PROHIBITED CONDUCT</strong>
              You agree to use the Site and Services only for purposes that are
              legal, proper and in accordance with these Terms of Service and
              any applicable laws, rules and regulations. You may not:
            </p>
            <ul>
              <li>
                use the Site or the Services in any manner that could damage,
                disable, overburden, or impair the Site or the Services, or
                interfere with any other party's use and enjoyment of the Site
                or the Services;
              </li>
              <li>
                attempt to gain unauthorized access to the Site, the Services,
                or the devices, computer systems or networks connected to the
                Site or the Services through hacking, password mining or any
                other means;
              </li>
              <li>
                create user accounts by automated means or under false or
                fraudulent pretenses;
              </li>
              <li>
                transmit any viruses, worms, defects, Trojan horses, or any
                items of a destructive nature;
              </li>
              <li>
                defame, abuse, harass, stalk, threaten or otherwise violate the
                legal rights (such as rights of privacy and publicity) of
                others;
              </li>
              <li>
                upload, post, email or transmit, or otherwise make available
                through the Site or the Services any inappropriate, defamatory,
                infringing, obscene, or unlawful content;
              </li>
              <li>
                upload, post, email or transmit, or otherwise make available
                through the Site or the Services any content that infringes any
                patent, trademark, copyright, trade secret or other proprietary
                right of any party, unless you are the owner of such rights or
                have the permission of the owner to post such content;
              </li>
              <li>
                upload, post, email or transmit, or otherwise make available
                through the Site or the Services any materials that promote
                pyramid schemes, chain letters or disruptive commercial messages
                or advertisements, or anything else prohibited by law;
              </li>
              <li>
                run Mail list, Listserv, or any form of auto-responder or "spam"
                on the Site or the Services;
              </li>
              <li>
                use manual or automated software, devices, or other processes to
                "crawl" or "spider" any page of the Site, including to engage in
                the practices of "screen scraping," "database scraping" or any
                other activity with the purpose of obtaining content or other
                information;
              </li>
              <li>
                interfere or attempt to interfere with the proper working of the
                Site or the Services or any activities conducted on the Site or
                the Services, including to utilize framing techniques to enclose
                any Site Content or other proprietary information, place pop-up
                windows over the Site's pages, or otherwise affect the display
                of the Site's pages;
              </li>
              <li>
                download any file posted by another user that you know, or
                reasonably should know, cannot be legally distributed in such
                manner;
              </li>
              <li>
                impersonate another person or entity, or falsify or delete any
                author attributions, legal or other proper notices or
                proprietary designations or labels of the origin or source of
                any materials;
              </li>
              <li>
                remove any copyright, trademark or other proprietary rights
                notices contained in or on the Site or the Services;
              </li>
              <li>
                use any robot, spider, site search/retrieval application, or
                other device to retrieve or index any portion of the Site or the
                Services or collect information about its Users for any
                unauthorized purpose;
              </li>
              <li>
                submit content that falsely expresses or implies that such
                content is sponsored or endorsed by the Company, any of its
                affiliates or any third parties;
              </li>
              <li>
                use the Site or the Services for any illegal or unauthorized
                purpose (including, without limitation, in violation of any
                United States federal and state laws or regulations, or
                equivalent laws or regulations in foreign jurisdictions;
              </li>
              <li>
                promote or provide instructional information about illegal
                activities or promote physical harm or injury against any group
                or individual;
              </li>
              <li>
                share or disclose with anyone any information obtained through
                the Site or the Services about any investment offerings; or
              </li>
              <li>
                use the Site or the Services for any commercial purpose
                whatsoever other than for your personal use.
              </li>
            </ul>
            <p>
              <strong>9. LINKED SITES</strong>The Site may contain links to
              other Internet sites, applications and resources. Links found on
              the Site may let users leave the Site and go to sites operated by
              parties other than the Company, including sites for payment for
              Services or other functions. The Company does not endorse, and is
              not responsible or liable in any way for any content, advertising,
              services or goods on or available from such linked sites,
              applications or resources. The linked sites, applications or
              resources are not under the control of the Company and we are not
              responsible for the contents of any linked site, application or
              resource, or any link contained in a linked site, application or
              resource that is not owned and operated by the Company, or any
              changes or updates to such sites, applications or resources. Such
              links to sites, applications or resources maintained by third
              parties do not constitute an endorsement, guaranty, or warranty by
              the Company, or any of its affiliates, of any third party or their
              content, nor the existence of a partnership, joint venture,
              agency, or other relationship between the Company, or any of its
              affiliates, and any linked third party or their content. The
              Company does not assume any responsibility or liability for the
              actions, products, content and/or information of these and other
              third parties and/or their sites, applications or resources. Third
              parties’ sites are not subject to our Terms of Service and Privacy
              Policy. You should carefully review their privacy statements and
              other conditions of use.
              <strong>10. DISCLAIMERS</strong>YOU UNDERSTAND THAT THE PROCESSING
              AND TRANSMISSION OF COMMUNICATIONS RELATING TO THE USE OF THE SITE
              OR THE SERVICES, INCLUDING YOUR DATA, MAY INVOLVE TRANSMISSIONS
              OVER VARIOUS NETWORKS AND CHANGES TO CONFORM AND ADAPT TO
              TECHNICAL REQUIREMENTS OF CONNECTING TO VARIOUS NETWORKS OR
              DEVICES. THEREFORE, YOU AGREE THAT COMPANY WILL NOT BE LIABLE FOR
              THE TIMELINESS, DELETION, MIS-DELIVERY OR FAILURE TO STORE ANY
              DATA, INFORMATION OR CONTENT TRANSMITTED BY YOU THROUGH THE
              SITE.COMPANY PROVIDES THE SITE AND THE SERVICES ON AN "AS IS" AND
              "AS AVAILABLE" BASIS. WITHOUT ANY WARRANTY OR CONDITION, EXPRESS
              OR IMPLIED. TO THE FULL EXTENT PERMISSIBLE UNDER APPLICABLE LAW,
              COMPANY SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES INCLUDING,
              WITHOUT LIMITATION, IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. COMPANY
              MAKES NO REPRESENTATION OR WARRANTY, AND HEREBY DISCLAIMS ANY
              REPRESENTATION OR WARRANTY, THAT (I) THE SITE OR THE SERVICES WILL
              MEET YOUR EXPECTATIONS OR REQUIREMENTS, (II) THE SITE OR THE
              SERVICES WILL BE UNINTERRUPTED, TIMELY, ACCURATE, SECURE, COMPLETE
              OR ERROR-FREE, (III) ANY RESULTS OR INFORMATION THAT MAY BE
              OBTAINED FROM THE USE OF THE SITE OR THE SERVICES WILL BE
              ACCURATE, TIMELY, COMPLETE OR RELIABLE AND (IV) ANY ERRORS IN ANY
              SOFTWARE USED ON THE SITE OR IN CONNECTION WITH THE SERVICES WILL
              BE CORRECTED. OPERATION OF THE SITE MAY BE INTERFERED WITH BY
              NUMEROUS FACTORS OUTSIDE OF COMPANY'S CONTROL INCLUDING, BUT NOT
              LIMITED TO, TELECOMMUNICATIONS NETWORK DISRUPTIONS. COMPANY IS NOT
              RESPONSIBLE AND WILL HAVE NO LIABILITY FOR ANY FAILURES OF THE
              INTERNET OR ANY DATA OR TELECOMMUNICATIONS EQUIPMENT, SYSTEM OR
              NETWORK USED IN CONNECTION WITH THE SITE OR THE SERVICES. TO THE
              FULLEST EXTENT PERMITTED BY APPLICABLE LAW, WE MAKE NO, AND
              DISCLAIM ALL, REPRESENTATIONS OR WARRANTIES WITH REGARD TO THE
              SUFFICIENCY OF THE SECURITY MEASURES USED FOR DATA HANDLING AND
              STORAGE, AND WE WILL NOT BE RESPONSIBLE FOR ANY ACTUAL,
              CONSEQUENTIAL SPECIAL OR INCIDENTAL DAMAGES THAT RESULT FROM A
              LAPSE IN COMPLIANCE WITH OUR PRIVACY POLICY BECAUSE OF A SECURITY
              BREACH OR TECHNICAL MALFUNCTION.WHILE WE HAVE ENDEAVORED TO CREATE
              A SECURE AND RELIABLE SITE, THE COMPANY IS NOT RESPONSIBLE FOR THE
              SECURITY OF INFORMATION TRANSMITTED VIA THE INTERNET, THE ACCURACY
              OF THE INFORMATION CONTAINED ON THE SITE, OR FOR THE CONSEQUENCES
              OF ANY RELIANCE ON SUCH INFORMATION. YOU MUST MAKE YOUR OWN
              DETERMINATION AS TO THESE MATTERS. THE COMPANY AND ITS AFFILIATES
              SHALL NOT BE LIABLE FOR DAMAGES AS A RESULT OF ANY DELAY OR OTHER
              FAILURE OF PERFORMANCE DUE TO CAUSES BEYOND ITS REASONABLE CONTROL
              INCLUDING, WITHOUT LIMITATION, ACTS OF GOD, ACTS OF CUSTOMER OR
              ANY OF ITS REPRESENTATIVES, ACTS OF MILITARY OR CIVIL AUTHORITIES,
              FIRE OR OTHER CASUALTY, STRIKES, LOCKOUTS, WEATHER, EPIDEMIC, WAR,
              RIOT, TERRORISM, TELECOMMUNICATIONS INTERRUPTIONS OR COMPUTER
              VIRUSES. THE SITE MAY BE TEMPORARILY UNAVAILABLE FROM TIME TO TIME
              FOR MAINTENANCE OR OTHER REASONS. &nbsp;
              <strong>11. LIMITATION ON LIABILITY</strong>IN NO EVENT SHALL
              COMPANY, ITS AFFILIATES OR ITS LICENSORS, TOGETHER WITH ITS AND
              THEIR RESPECTIVE EMPLOYEES, AGENTS, DIRECTORS, OFFICERS AND
              SHAREHOLDERS (THE “COMPANY PARTIES”), BE LIABLE (HOWEVER ARISING,
              INCLUDING NEGLIGENCE) FOR (I) ANY LOST OR CORRUPTED DATA, LOST
              PROFITS OR ANY SPECIAL, INCIDENTAL, INDIRECT OR CONSEQUENTIAL
              DAMAGES, EVEN IF COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGES OR (II) THE COST OF PROCURING SUBSTITUTE GOODS,
              SERVICES OR TECHNOLOGY. SOME JURISDICTIONS MAY NOT ALLOW THE
              EXCLUSION OR LIMITATION OF CERTAIN DAMAGES, SO THE ABOVE
              EXCLUSIONS SHALL ONLY APPLY TO THE EXTENT PERMISSIBLE UNDER
              APPLICABLE LAW. TO THE FULL EXTENT PERMISSIBLE UNDER APPLICABLE
              LAW, COMPANY'S AND COMPANY PARTIES’ COLLECTIVE AGGREGATE LIABILITY
              TO YOU OR ANY THIRD PARTY IN ANY CIRCUMSTANCE IS LIMITED TO THE
              GREATER OF (A) THE AGGREGATE OF THE AMOUNT PAID BY YOU TO THE
              COMPANY FOR THE SERVICES DURING THE TWELVE (12) MONTH PERIOD
              IMMEDIATELY PRECEDING THE DATE THAT ANY CLAIM ARISES OR (B) $100.
              <strong>12. INDEMNITY</strong>Except to the extent prohibited
              under applicable law, you agree to defend, indemnify and hold
              Company and its affiliates, together with its and their respective
              employees, agents, directors, officers and shareholders, harmless
              from and against all liabilities, losses, claims, damages, costs
              and expenses (including reasonable attorneys' fees and costs
              including any incurred in enforcement of this provision) arising
              out of (i) your use or misuse of the Site or the Services, (ii)
              your breach or alleged breach of these Terms of Service, and (iii)
              your violation of any law, rule, regulation or violation of any
              rights of others in connection with your use of the Site or the
              Services.<strong>13. TERMINATION</strong>
              You agree that Company, in its sole discretion and without prior
              notice or liability to you, may issue a warning, temporarily
              suspend, indefinitely suspend, or terminate your account, at our
              sole discretion, for any reason, whether with or without cause or
              warning, and without liability. In the event of termination of
              your account, the Company may delete and/or store, in its
              discretion, data associated with your use of the Site. In the
              event of termination, the Company has no further obligations to
              you.
              <strong>14. MISCELLANEOUS</strong>These Terms of Service
              constitute the entire agreement between you and Company with
              respect to your access and use of the Site and the Services and
              supersedes all prior and contemporaneous agreements between you
              and Company. If any of the provisions of these Terms of Service is
              found by a court of competent jurisdiction to be invalid or
              unenforceable, then that provision will be construed in a manner
              consistent with applicable laws to reflect, as nearly as possible,
              the original intentions of the parties, and the remaining
              provisions shall remain in full force and effect. The failure of
              Company to exercise or enforce any right or provision of the Terms
              of Service shall not constitute a waiver of such right or
              provision. The provisions of Sections 3-8, and 11-15 shall survive
              any termination of these Terms of Service.This Site is targeted at
              and intended for visitors residing in the United States. Given the
              global nature of the Internet, however, the Site may be accessed
              by visitors residing outside of the United States. We make no
              representations or warranties that the Site is appropriate or
              available for use in countries outside of the United States.
              Visitors who choose to access the Site from outside of the United
              States do so at their own initiative and are responsible for
              compliance with any and all local laws and regulations that may
              apply to such access.The laws applicable to the interpretation of
              these Terms of Service shall be the laws of the State of
              California, and applicable federal law, without regard to any
              conflict of law provisions. You agree to submit to the personal
              and exclusive jurisdiction of the state and federal courts located
              within the county of Los Angeles, California.Any and all
              controversies, disputes, demands, counts, claims, or causes of
              action (including the interpretation and scope of this clause, and
              the arbitrability of the controversy, dispute, demand, count,
              claim, or cause of action) between you and the Company or its
              successors or assigns shall exclusively be settled through binding
              and confidential arbitration.Arbitration shall be subject to the
              Federal Arbitration Act and not any state arbitration law. Unless
              otherwise agreed upon by the parties in writing, the arbitration
              will be conducted before one arbitrator and will be governed by
              the American Arbitration Association’s (“AAA”) Commercial
              Arbitration Rules and, if the arbitrator deems them applicable,
              the Supplementary Procedures for Consumer Related Disputes
              (collectively, the “Rules and Procedures”).To the fullest extent
              permitted by applicable law, you and the Company must abide by the
              following rules: (1) ANY CLAIMS BROUGHT BY YOU OR THE COMPANY MUST
              BE BROUGHT IN THE PARTY’S INDIVIDUAL CAPACITY, AND NOT AS A
              PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
              PROCEEDING; (2) THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE
              PERSON’S CLAIMS, MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A
              REPRESENTATIVE OR CLASS PROCEEDING, AND MAY NOT AWARD CLASS-WIDE
              RELIEF; (3) the arbitration shall be confidential, and neither you
              nor the Company may disclose the existence, content or results of
              any arbitration, except as may be required by law or for purposes
              of enforcement of the arbitration award; (4) the arbitrator may
              award any individual relief or individual remedies that are
              permitted by applicable law; and (5) each side pays its own
              attorneys’ fees and expenses unless there is a statutory provision
              that requires the prevailing party to be paid its fees and
              litigation expenses, and, in such instance, the fees and costs
              awarded shall be determined by the applicable law.
              <strong>15. ASSIGNMENT</strong>The Company may assign these Terms
              of Service at any time to a subsidiary or parent company or to a
              successor to its business as part of a merger or sale of
              substantially all of its assets. You may not assign or transfer
              these Terms of Service. If any provision of this Terms of Service
              is held to be unenforceable for any reason, the remaining
              provisions will be unaffected and remain in full force and effect.
              For any questions or comments, or to report violations of these
              Terms of Service, including receipt of spam from a user, contact
              the Company at:&nbsp;kit@sacuddin.shop with “Terms of Service” in
              the subject line of your email.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
